import styled from "styled-components";

export const StyledHeaderTitle = styled.h1`
  font-size: 3rem;
  line-height: 3.8rem;
  max-width: 100%;
  color: var(--text-color);
  @media screen and (max-width: 1280px) {
    display: flex;
    align-items: center;
  }
  @media screen and (max-width: 992px) {
    line-height: 4.2rem;
    font-size: 3rem;
  }
`;

export const StyledHeader = styled.div`
  width: 100%;
  padding: 2rem 0;
  position: relative;
  background-color: var(--text-color);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--text-color);
  @media screen and (max-width: 1280px) {
    height: auto;
    padding-bottom: 2rem;
  }
  * {
    color: ${(props) => props["data-dark"] && "var(--text-color)"};
  }
`;
const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
const StyledContainer = styled.div`
  max-width: 1280px;
  width: calc(100% - 4rem);
  display: flex;
  padding: 4rem 0;
  gap: 3rem;
  @media screen and (max-width: 1280px) {
    flex-direction: column;
  }
  h2 {
    font-size: 2rem;
    line-height: 1.3;
  }
  h3 {
    font-size: 1.5rem;
    line-height: 1.3;
  }
  h4 {
    font-size: 1.3rem;
    line-height: 1.3;
  }
`;
const StyledBlock = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const StyledImageBlock = styled.div`
  flex: 2;
  position: relative;
`;

const StyledImage = styled.img`
  position: absolute;
  top: 20%;
  left: 0;
  width: 100%;
  @media screen and (max-width: 1280px) {
    width: auto;
    max-width: 100%;
    position: static;
  }
`;
const StyledImageTwo = styled.img`
  position: absolute;
  top: calc(20% + 4rem);
  right: 0;
  width: 30%;
  @media screen and (max-width: 1280px) {
    display: none;
  }
`;
const BottomContent = ({ dark, singleData }) => {
  /*
  if (!singleData?.bottomContent) {
    return null;
  }
  */

  const bottomContent = {
    title: `Start cleaning your ${singleData.title} account easily.`,
    imageOne: "/images/deletion-instructions.png",
    steps: [
      {
        title: "STEP 1",
        subheader: `Sign in to Redact's ${singleData.title} service`,
        content:
          "Redact is available on PC, Mac, Linux, and the Google and iOS app stores. Install and you're good to go. (some services may be unavailable on mobile devices)",
      },
      {
        title: "STEP 2",
        subheader: "Choose the method of deletion",
        content: `
        Redact offer a wide range of rule options, specifying what content and where to find it. There are multiple methods of deletions also such as:
        <br/><br/>
Preview Mode: For just viewing the potential deletion items based on the form
<br/><br/>
Deletion Mode: Where you want to get straight in deleting content
<br/><br/>
Select and Delete: Where you pick what items to be deleted by batches of 10.`,
      },
      {
        title: "STEP 3",
        subheader: "Watch your content deletion in real time",
      },
    ],
  };
  return (
    <StyledWrapper data-dark={dark}>
      <StyledContainer>
        <StyledBlock>
          <h2>{bottomContent.title}</h2>
          {bottomContent.steps.map((step) => {
            return (
              <div style={{ marginBottom: "1rem" }} key={step.title}>
                <h3 style={{ color: "#604AFF", letterSpacing: "4px" }}>{step.title}</h3>
                <h4>{step.subheader}</h4>
                <div className="markdown" dangerouslySetInnerHTML={{ __html: step.content }} />
              </div>
            );
          })}
        </StyledBlock>
        <StyledImageBlock>
          {bottomContent.imageOne && (
            <StyledImage src={bottomContent.imageOne} alt="desktop preview" />
          )}
        </StyledImageBlock>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default BottomContent;
